import {QueryOptions} from 'select2';
import {KinolaRepeater} from './repeater';

class KinolaSelect2 {
    public init(selector: string, ajaxSelector: string, containerSelector: string): void {
        const $container = $(containerSelector);

        $container.find(selector).each((index: number, element: HTMLElement): void => {
            this.initSelect2($(element));
        });
        $container.find(ajaxSelector).each((index: number, element: HTMLElement): void => {
            this.initSelect2Ajax($(element));
        });

        $(document).on('repeaterElementAdd', KinolaRepeater.repeaterRowSelector, (e) => {
            this.initSelect2($(e.target).find(selector));
            this.initSelect2Ajax($(e.target).find(ajaxSelector));
        });
    }

    public initSelect2(element: JQuery<HTMLElement>): void {
        element.select2({width: '100%'});
    }

    public initSelect2Ajax(element: JQuery<HTMLElement>): void {
        element.select2({
            width: '100%',
            ajax: {
                url: $(element).data('get-items-route'),
                data: (params: QueryOptions): object => ({
                    search: params.term,
                    type: $(element).data('get-items-field'),
                    method: $(element).data('method'),
                    page: params.page || 1,
                }),
            },
        });
    }
}

const kinolaSelect2: KinolaSelect2 = new KinolaSelect2();
kinolaSelect2.init(
    '.js-kinola-select2',
    '.js-kinola-select2-ajax',
    '.js-kinola-repeater-container',
);
